import React, { useEffect, useState } from 'react';
import Phone from '../Phone/Phone';
import { ReactComponent as TooltipIcon } from './tooltip.svg';
import { Prompt } from 'react-router-dom';
import { api } from '../../../redux/setupAxios';
import { useSelector } from 'react-redux';
import { updateSettings } from '../../helper/updateSettings';

function validURL(str) {
	let pattern = new RegExp(
		'^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$',
		'i',
	); // fragment locator
	return !!pattern.test(str);
}

const CustomerSupport = () => {
	const { merchantId, currentMerchant } = useSelector(
		state => ({
			merchantId: state.auth.user.merchantId,
			merchantOptions: state.merchants.merchants[0].options,
			currentMerchant: state.auth.user.merchants[0],
		}),
	);
	const [defaultSettings, setDefaultSettings] = useState({
		active: false,
		link: '',
		tagPost: false,
	});
	const [settings, setSettings] = useState(defaultSettings);
	const [isBlocking, setIsBlocking] = useState(false);
	const [alert, setAlert] = useState({
		display: false,
		message: '',
		type: '',
	});

	useEffect(() => {
		const loadData = async () => {
			try {
				const { data } = await api.post('merchants/get-options');
				const initData = {};
				for (const [key, value] of Object.entries(data)) {
					if (Object.keys(defaultSettings).includes(key)) {
						initData[key] = value;
					}
				}
				const newSettings = { ...defaultSettings, ...initData };
				setDefaultSettings(newSettings);
				setSettings(newSettings);
			} catch (error) {
				console.error(error);
			}
		};
		loadData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const hasError = () => {
		let errors = [];
		if (settings.link !== defaultSettings.link && !validURL('https://' + settings.link)) {
			errors.push('Invalid Url');
		}
		if (errors.length) {
			return errors;
		} else {
			return false;
		}
	};

	const saveSettings = async () => {
		try {
			setAlert({ display: false });
			const errors = hasError();
			if (errors && errors?.length) {
				setAlert({ display: true, message: errors.join(','), type: 'danger' });
			} else {
				currentMerchant.options = { ...currentMerchant.options, ...settings }
				await updateSettings(currentMerchant, merchantId);
				setAlert({ display: true, message: 'Data saved successfully', type: 'primary' });
				setIsBlocking(false);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleChange = e => {
		if (e.target.type === 'checkbox') {
			setSettings({ ...settings, [e.target.name]: !settings[e.target.name] });
		} else {
			if (e.target.name === 'link') {
				setSettings({
					...settings,
					[e.target.name]: e.target.value.replace(/^(https:\/\/)/, ''),
				});
			} else {
				setSettings({ ...settings, [e.target.name]: e.target.value });
			}
		}
	};
	useEffect(() => {
		const diff = Object.keys(defaultSettings).some(key => defaultSettings[key] !== settings[key]);
		setIsBlocking(diff);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settings]);
	return (
		<>
			<div className='page-wrapper'>
				<Prompt
					when={isBlocking}
					// message={location => `Are you sure you want to go to ${location.pathname}`}
					message={location => `Save your modification?`}
				/>
				<div className='col-xxl-5'>
					<div className='card-visibility'>
						<div className='card-vi-header'>
							<span className='fw-bold text-dark'>Customer Support</span>
						</div>

						<div className='card-body-visibility'>
							<div className='bah-accordion'>
								<div className='bah-accordion__element customer-support'>
									{alert.display && (
										<div
											profile='alert'
											className={`mb-10 alert alert-custom alert-light-${alert.type} alert-dismissible`}
										>
											<div className='alert-text font-weight-bold'>{alert.message}</div>
										</div>
									)}
									{/* <div className='container-input'>
										<label className='input-label'>Active CS</label>
										<span className='switch switch-icon'>
											<label className='switch-label'>
												<input type='checkbox' name='select' />
												<span className='checkbox-input'></span>
											</label>
										</span>
									</div> */}
									<div className='container-input'>
										<label className='input-label'>
											Activate customer support
											<div className='tooltips'>
												<TooltipIcon />
												<span className='tooltiptexts'>
													Explanation of what position on desktop means
												</span>
											</div>
										</label>
										<span className='switch switch-icon'>
											<label className='switch-label'>
												<input
													type='checkbox'
													name='active'
													value='active'
													checked={settings.active}
													onClick={handleChange}
													onChange={() => { }}
												/>
												<span className='checkbox-input'></span>
											</label>
										</span>
									</div>
									<div className='container-input'>
										<label className='input-label'>Add link</label>
										<div className='input-group'>
											<div className='input-group-prepend'>
												<span className='input-group-text input-control-span'>https://</span>
											</div>
											<input
												type='url'
												className='form-control input-control'
												name='link'
												value={settings.link}
												onChange={handleChange}
											/>
										</div>
									</div>
									<div className='container-input'>
										<label className='input-label'>Tag all posts containing words as CS </label>
										<span className='switch switch-icon'>
											<label className='switch-label'>
												<input
													type='checkbox'
													name='tagPost'
													value='tagPost'
													checked={settings.tagPost}
													onClick={handleChange}
													onChange={() => { }}
												/>
												<span className='checkbox-input'></span>
											</label>
										</span>
									</div>
									<span className='name-remember'>
										These posts will be automatically hidden from the community
									</span>
								</div>
							</div>
						</div>
					</div>
					<div className='my-4 save-btn-wrapper'>
						<button className='btn btn-dark' onClick={saveSettings}>
							Publish
						</button>
					</div>
				</div>
				<Phone />
			</div>
		</>
	);
};

export default CustomerSupport;
